export const useDateStore = defineStore("date", () => {
  const translate = useTranslationStore();

  function dateObjToFormattedDate(
    date: Date,
    full?: boolean,
    monthOnly?: boolean,
  ) {
    const monthFormat = full ? "long" : "short";
    try {
      const month = new Intl.DateTimeFormat(
        [translate.currentLanguageCode, "en-US"],
        {
          month: monthFormat,
        },
      ).format(date);
      const day = new Intl.DateTimeFormat(
        [translate.currentLanguageCode, "en-US"],
        {
          day: "numeric",
        },
      ).format(date);
      const year = new Intl.DateTimeFormat(
        [translate.currentLanguageCode, "en-US"],
        {
          year: "numeric",
        },
      ).format(date);

      if (full) {
        const dayOfWeek = new Intl.DateTimeFormat(
          [translate.currentLanguageCode, "en-US"],
          {
            weekday: "long",
          },
        ).format(date);
        if (monthOnly) {
          return `${dayOfWeek} - ${month} ${year}`;
        } else {
          return `${dayOfWeek} - ${day} ${month} ${year}`;
        }
      } else {
        if (monthOnly) {
          return `${month} ${year}`;
        } else {
          return `${day} ${month} ${year}`;
        }
      }
    } catch (err) {
      const month = new Intl.DateTimeFormat("en-US", {
        month: monthFormat,
      }).format(date);
      const day = new Intl.DateTimeFormat("en-US", {
        day: "numeric",
      }).format(date);
      const year = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
      }).format(date);
      if (full) {
        const dayOfWeek = new Intl.DateTimeFormat("en-US", {
          weekday: "long",
        }).format(date);
        if (monthOnly) {
          return `${dayOfWeek} - ${month} ${year}`;
        } else {
          return `${dayOfWeek} - ${day} ${month} ${year}`;
        }
      } else {
        if (monthOnly) {
          return `${month} ${year}`;
        } else {
          return `${day} ${month} ${year}`;
        }
      }
    }
  }

  function formatDate(date: string, full?: boolean, monthOnly?: boolean) {
    if (!date) {
      return "";
    }
    const [y, m, d] = date.split("-").map((i) => parseInt(i));
    const dateobj = new Date(y, m - 1, d);
    return dateObjToFormattedDate(dateobj, full, monthOnly);
  }

  function formatSlashedDate(date: string) {
    const [m, d, y] = date.split("/").map((i) => parseInt(i));
    const dateobj = new Date(y, m - 1, d);
    return dateObjToFormattedDate(dateobj);
  }

  function getShortMonth(date: string) {
    return new Intl.DateTimeFormat([translate.currentLanguageCode, "en-US"], {
      month: "short",
    }).format(new Date(date + "T00:00:00"));
  }

  function getFullMonth(date: string) {
    return new Intl.DateTimeFormat([translate.currentLanguageCode, "en-US"], {
      month: "long",
    }).format(new Date(date + "T00:00:00"));
  }

  return {
    dateObjToFormattedDate,
    formatDate,
    formatSlashedDate,
    getShortMonth,
    getFullMonth,
  };
});
